"use strict";

var _interopRequireDefault = require("/var/www/html/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es7.symbol.async-iterator");
require("core-js/modules/es6.symbol");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.to-string");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.number.constructor");
var _defineProperty2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.regexp.split");
var _slicedToArray2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));
var _toConsumableArray2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.object.freeze");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _lodash = _interopRequireDefault(require("lodash"));
var _pattern = require("@/api/pattern");
var _fansManage = _interopRequireDefault(require("./components/fans-manage"));
var _noGuideDialog = _interopRequireDefault(require("./components/no-guide-dialog"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    FansManage: _fansManage.default,
    NoGuideDialog: _noGuideDialog.default
  },
  data: function data() {
    return {
      tableData: [],
      summaryData: [],
      // 汇总表格数据
      totalPage: 1,
      currentPage: 1,
      perPage: 300,
      totalNumber: 0,
      // 总数量
      loading: true,
      summaryLoading: true,
      chooseData: {},
      issues: [],
      patterns: [],
      // 模型列表（使用 id）
      productPatterns: [],
      // 模型列表（使用 pattern_product_id）
      formData: {},
      userStatus: [{
        value: 0,
        label: '禁用'
      }, {
        value: 1,
        label: '在用'
      }, {
        value: 2,
        label: '备用'
      }],
      searchPatterns: [],
      // 搜索的模型
      searchAccepts: [],
      // 搜索的接粉部门
      searchGuides: [],
      // 搜索的导粉部门
      searchStatus: 1,
      // 搜索的模型状态，默认可用
      searchDimensions: [],
      // 搜索的维度
      showDimensions: [],
      // 展示的维度
      guideDepartments: [],
      // 导粉部门列表
      acceptDepartments: [],
      // 接粉部门列表
      dimensions: [],
      // 维度
      currentMonthText: '本月',
      isAllExpanded: false,
      // 是否全部展开
      noGuideDepartment: ''
    };
  },
  computed: {
    /** 是否显示模型相关列 */showPatternColumn: function showPatternColumn() {
      return this.showDimensions.includes('pattern') && this.tableData.some(function (row) {
        return !!row.pattern_info;
      });
    },
    /** 是否显示导粉部门列 */showGuideColumn: function showGuideColumn() {
      return this.showDimensions.includes('channel_group_name') && this.tableData.some(function (row) {
        return !!row.channel_group_name;
      });
    },
    /** 是否显示接粉部门列 */showAcceptColumn: function showAcceptColumn() {
      return this.showDimensions.includes('department') && this.tableData.some(function (row) {
        return !!row.department;
      });
    },
    /** 是否显示仅管理员可看相关列 */showManagerColumn: function showManagerColumn() {
      return this.tableData.some(function (row) {
        return typeof row.offline_amount === 'number';
      });
    }
  },
  mounted: function mounted() {
    this.pageInit();
    this.getSummaryData();
  },
  methods: {
    pageInit: function () {
      var _pageInit = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;
        var _yield$getPatternMap, data, dimensionKeys, dimensions, showDimensions, searchDimensions, i, key, label;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _pattern.getPatternMap)();
            case 2:
              _yield$getPatternMap = _context.sent;
              data = _yield$getPatternMap.data;
              this.issues = data.issue_config.map(function (item) {
                return {
                  label: item.value,
                  value: item.id
                };
              });
              // 接粉部门
              this.acceptDepartments = data.jie_fen_department.map(function (v) {
                return {
                  label: v,
                  value: v
                };
              });
              // 导粉部门
              this.guideDepartments = data.dao_fen_department.map(function (v) {
                return {
                  label: v,
                  value: v
                };
              });
              // 默认导粉部门全选上
              this.searchGuides = this.guideDepartments.map(function (item) {
                return item.value;
              });
              dimensionKeys = Object.keys(data.dimension); // 统计维度
              dimensions = [], showDimensions = [], searchDimensions = [];
              for (i = 0; i < dimensionKeys.length; i++) {
                key = dimensionKeys[i];
                label = data.dimension[key];
                dimensions.push({
                  label: label,
                  value: key
                });
                // 默认维度为模型名称、接粉部门
                if (['pattern', 'department'].includes(key)) {
                  showDimensions.push(key);
                  searchDimensions.push(label);
                }
              }
              this.dimensions = dimensions;
              this.showDimensions = showDimensions;
              this.searchDimensions = searchDimensions;

              // 链接上有带模型id的话，优先走查询流程
              if (this.$route.query.pattern_id) {
                this.searchPatterns = [this.$route.query.pattern_id];
                this.onSearch();
              } else {
                this.getList();
              }
              (0, _pattern.getPatternList)({
                page: 1,
                per_page: 200 // 需要拿到全部数据，先默认200
              }).then(function (_ref) {
                var code = _ref.code,
                  data = _ref.data;
                if (code === 200) {
                  _this.patterns = data.list.map(function (item) {
                    return {
                      label: item.remark,
                      value: item.id
                    };
                  });
                  _this.productPatterns = data.list.map(function (item) {
                    return {
                      label: item.remark,
                      value: item.pattern_product_id
                    };
                  });
                }
              });
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function pageInit() {
        return _pageInit.apply(this, arguments);
      }
      return pageInit;
    }(),
    // 获取汇总数据
    getSummaryData: function getSummaryData() {
      var _this2 = this;
      (0, _pattern.getPatternSummaryList)().then(function (_ref2) {
        var data = _ref2.data;
        var list = data.list,
          meta = data.meta;
        _this2.summaryData = list;
        if (meta) {
          if (meta.start_at && meta.end_at) {
            _this2.currentMonthText = "\u672C\u6708\uFF08".concat(meta.start_at, "\uFF5E").concat(meta.end_at, "\uFF09");
          }
        }
      }).finally(function () {
        _this2.summaryLoading = false;
      });
    },
    getList: function getList() {
      var _this3 = this;
      var params = {
        page: this.currentPage,
        per_page: this.perPage,
        status: this.searchStatus
      };
      // 模型
      if (this.searchPatterns.length > 0) {
        params.pattern_product_ids = this.searchPatterns.join(',');
      }
      // 导粉部门
      if (this.searchGuides.length > 0) {
        params.df_department = this.searchGuides.join(',');
      }
      // 接粉部门
      if (this.searchAccepts.length > 0) {
        params.jf_department = this.searchAccepts.join(',');
      }
      // 维度
      if (this.showDimensions.length > 0) {
        params.dimension = this.showDimensions.join(',');
      }
      (0, _pattern.getPatternDetailList)(params).then(function (_ref3) {
        var code = _ref3.code,
          data = _ref3.data;
        if (code === 200) {
          var list = data.list,
            meta = data.meta;
          var newList = _this3.getFinalList(list);
          _this3.tableData = Object.freeze(newList);
          _this3.totalPage = meta.page.total_page;
          _this3.totalNumber = meta.page.total;
        }
      }).finally(function () {
        _this3.loading = false;
      });
    },
    getFinalList: function getFinalList(list) {
      var _this4 = this;
      var genderMap = {
        male: '男',
        female: '女',
        both: '全部性别'
      };
      var issueMap = {};
      this.issues.forEach(function (_ref4) {
        var label = _ref4.label,
          value = _ref4.value;
        return issueMap[value] = label;
      });
      var newList = list.map(function (item) {
        var _item$pattern_info = item.pattern_info,
          pattern_info = _item$pattern_info === void 0 ? {} : _item$pattern_info;
        var basket = pattern_info.basket,
          issue = pattern_info.issue;
        var guideTime = [],
          ages = [],
          gender = 'both',
          settingTags = [],
          nextPatternList = [];
        if (basket) {
          if (basket.guide_time) {
            var originGuideTimeList = basket.guide_time;
            var _iterator = _createForOfIteratorHelper(originGuideTimeList),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var timeItem = _step.value;
                var _timeItem$split = timeItem.split('-'),
                  _timeItem$split2 = (0, _slicedToArray2.default)(_timeItem$split, 2),
                  startTime = _timeItem$split2[0],
                  endTime = _timeItem$split2[1];
                // 获取时分
                var sHM = _this4.getHourAndMinute(startTime);
                var eHM = _this4.getHourAndMinute(endTime);
                // 日期
                var starDate = new Date(2024, 0, 1, sHM.hour, sHM.minute);
                var endDate = new Date(2024, 0, 1, eHM.hour, eHM.minute);
                var newTimeItem = [starDate, endDate];
                guideTime.push(newTimeItem);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            settingTags.push.apply(settingTags, (0, _toConsumableArray2.default)(basket.guide_time));
          }
          if (basket.age) {
            var _iterator2 = _createForOfIteratorHelper(basket.age),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var range = _step2.value;
                var _range$split = range.split('-'),
                  _range$split2 = (0, _slicedToArray2.default)(_range$split, 2),
                  min = _range$split2[0],
                  max = _range$split2[1];
                ages.push([parseInt(min), parseInt(max)]);
                settingTags.push("".concat(min, "\u5C81-").concat(max, "\u5C81"));
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
          if (basket.gender) {
            gender = basket.gender;
            settingTags.push(genderMap[gender]);
          }
          if (basket.next_pid) {
            for (var _i = 0, _Object$keys = Object.keys(basket.next_pid); _i < _Object$keys.length; _i++) {
              var k = _Object$keys[_i];
              nextPatternList.push(_objectSpread({
                id: k
              }, basket.next_pid[k]));
            }
          }
          if (basket.guide_time_pid) {
            for (var _i2 = 0, _Object$keys2 = Object.keys(basket.guide_time_pid); _i2 < _Object$keys2.length; _i2++) {
              var _k = _Object$keys2[_i2];
              settingTags.push("".concat(basket.guide_time_pid[_k].value).concat(basket.guide_time_pid[_k].ratios, "%"));
            }
          }
          basket.o_sum && (item.o_sum = parseInt(basket.o_sum));
        }
        return _objectSpread(_objectSpread(_objectSpread({}, item), pattern_info), {}, {
          guideTime: guideTime,
          ages: ages,
          gender: gender,
          settingTags: settingTags,
          issueName: issueMap[issue],
          nextPatternList: nextPatternList
        });
      });
      return newList;
    },
    getHourAndMinute: function getHourAndMinute(time) {
      var _time$split = time.split(':'),
        _time$split2 = (0, _slicedToArray2.default)(_time$split, 2),
        hour = _time$split2[0],
        minute = _time$split2[1];
      hour = Number(hour);
      minute = Number(minute);
      return {
        hour: hour,
        minute: minute
      };
    },
    onSearch: function onSearch() {
      var _this5 = this;
      this.loading = true;
      // 搜索重置
      this.totalPage = 1;
      this.currentPage = 1;
      var showDimensions = [];
      this.searchDimensions.forEach(function (val) {
        var findItem = _this5.dimensions.find(function (item) {
          return item.label === val;
        });
        if (findItem) {
          showDimensions.push(findItem.value);
        }
      });
      this.showDimensions = showDimensions;
      this.getList();
    },
    onReset: function onReset() {
      this.searchPatterns = [];
      this.searchAccepts = [];
      this.searchGuides = [];
      this.searchStatus = '';
    },
    // 分页
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loading = true;
      this.getList();
    },
    onModify: function onModify(val) {
      this.chooseData = _lodash.default.cloneDeep(val);
      this.$refs.managePop.dialogVisible = true;
    },
    getHeaderCellStyle: function getHeaderCellStyle() {
      return {
        backgroundColor: '#f8faff'
      };
    },
    // 全选
    onSelectAll: function onSelectAll() {
      this.searchPatterns = this.productPatterns.map(function (item) {
        return item.value;
      });
    },
    onSelectAllGuideDepartments: function onSelectAllGuideDepartments() {
      this.searchGuides = this.guideDepartments.map(function (item) {
        return item.value;
      });
    },
    onSelectAllAcceptDepartments: function onSelectAllAcceptDepartments() {
      this.searchAccepts = this.acceptDepartments.map(function (item) {
        return item.value;
      });
    },
    getStatusText: function getStatusText(value) {
      var findItem = this.userStatus.find(function (item) {
        return item.value === value;
      });
      return findItem ? findItem.label : '';
    },
    // 切换全部展开/收起
    toggleExpandAll: function toggleExpandAll() {
      this.isAllExpanded = !this.isAllExpanded;
    },
    // 处理排序变化事件（实现多级排序）
    handleSortChange: function handleSortChange(_ref5) {
      var column = _ref5.column,
        prop = _ref5.prop,
        order = _ref5.order;
      // 如果是近十天订单产列，且需要多级排序
      if (prop === 'od_ltv' && order) {
        // 创建新数组（浅拷贝，只拷贝数组引用，不拷贝对象）
        var newData = (0, _toConsumableArray2.default)(this.tableData);
        newData.sort(function (a, b) {
          // 只读取数据进行比较，不修改对象
          var aOdLtv = parseFloat(a.od_ltv) || 0;
          var bOdLtv = parseFloat(b.od_ltv) || 0;

          // 第一优先级：比较订单产值
          if (aOdLtv !== bOdLtv) {
            var result = aOdLtv - bOdLtv;
            // 根据排序方向决定是否反转
            // descending: 降序，大的在前，所以反转结果（-result）
            // ascending: 升序，小的在前，不反转（result）
            return order === 'descending' ? -result : result;
          }

          // 第二优先级：订单产值相同时，按订单数降序（无论主排序方向如何）
          var aOrderCount = parseFloat(a.offline_yiqiangdao_od) || 0;
          var bOrderCount = parseFloat(b.offline_yiqiangdao_od) || 0;
          return bOrderCount - aOrderCount; // 降序：大的在前
        });

        // 更新表格数据（只改变数组顺序，对象引用保持不变）
        this.tableData = Object.freeze(newData);
      }
    },
    showNoGuideEntry: function showNoGuideEntry(row) {
      var qiangdao_od_rate = row.qiangdao_od_rate,
        keqiangdao_od = row.keqiangdao_od,
        channel_group_name = row.channel_group_name;
      if (qiangdao_od_rate === '100.00%' || keqiangdao_od === 0 || channel_group_name === '合计') {
        return false;
      }
      return true;
    },
    openNoGuideOrderDialog: function openNoGuideOrderDialog(row) {
      this.noGuideDepartment = row.channel_group_name;
      this.$refs.noGuideDialog.dialogVisible = true;
    }
  }
};